// /frontend/src/config/rfqConfig.js
// Konfigurasi untuk Request for Quotation mode

export const RFQ_CONFIG = {
  // Toggle untuk mengaktifkan/menonaktifkan mode RFQ
  isRFQMode: true,
  
  // Konfigurasi tampilan
  ui: {
    hideAllPrices: true,
    hidePriceColumns: true,
    showQuoteStatus: true,
    showEstimatedDelivery: false
  },
  
  // Teks untuk berbagai bagian
  texts: {
    placeOrderButton: 'Submit Quote Request',
    orderSummaryTitle: 'Request for Quotation',
    totalPriceLabel: 'Quote Required',
    statusPending: 'Pending Review',
    nextStepsTitle: 'What happens next?',
    confirmationTitle: 'Quote Request Submitted',
    paymentPageRedirect: true
  },
  
  // Konfigurasi email/notifikasi
  notifications: {
    confirmationMessage: 'Your request for quotation has been submitted successfully. Our team will review your requirements and send you a detailed quote within 24-48 hours.',
    estimatedResponseTime: '24-48 hours',
    contactEmail: 'quotes@hendersondesign.com'
  }
};

// Helper functions
export const isRFQModeEnabled = () => RFQ_CONFIG.isRFQMode;

export const shouldHidePrices = () => RFQ_CONFIG.isRFQMode && RFQ_CONFIG.ui.hideAllPrices;

export const getRFQTexts = () => RFQ_CONFIG.texts;

export const getNotificationConfig = () => RFQ_CONFIG.notifications;